import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
    Card,
    Col,
    Row,
    Button,
    Typography,
    Space,
    Flex,
    Select,
    Segmented,
} from "antd";
import {
    DownOutlined,
    UpOutlined,
} from "@ant-design/icons";
import './routingMap.scss';
import { useAntIcons } from "../../../hooks/useIcons";
import { getData } from "../../../actions/apiCall";
import EditAccess from "./EditAccess";
import { debounce } from 'lodash';

const { Text, Title } = Typography;

interface ItemRecord {
    status?: string;
    _id?: string;
    name: string;
    parentMenu?: string;
    createdAt?: string;
    updatedAt?: string;
    subparentMenu?: string;
    routeUrl?: string;
    componentName?: string;
    icon?: string;
    order: number;
    subMenu?: string;
    mainMenuRef?: any;
    subMenuRef?: any;
    parentMenuRef?: any;
    newTab?: any;
    list?: ItemRecord[];
}

const Access: React.FC = () => {
    const dispatch = useDispatch();
    const [mainMenueCollapse, setMainMenueCollapse] = useState<{ [key: number]: boolean }>({});
    const [subMenueCollapse, setSubMenueCollapse] = useState<{ [key: number]: boolean }>({});
    const [respRoutes, setRespRoutes] = useState<ItemRecord[]>([]);
    const [selectedItem, setSelectedItem] = useState<ItemRecord | null>(null);
    const { getIcon, iconNames } = useAntIcons();
    const [designation, setDesignation] = React.useState([]);
    const [role, setRole] = React.useState<string | null>(null);
    const [isPreview, setIsPreview] = React.useState(false);

    useEffect(() => {
        getDesignations();
        getRoutings();
    }, []);

    useEffect(() => {
        if (role) {
            getRoutings();
        }
    }, [role, isPreview]);

    const getRoutings = () => {
        dispatch(getData('/routing', { role, isPreview })).then((res) => {
            if (res) {
                setRespRoutes(res.data.sort((a, b) => a.order - b.order));
            }
        });
    };

    const toggleMainCollapse = (index: number) => {
        setMainMenueCollapse(prev => ({ ...prev, [index]: !prev[index] }));
    };

    const toggleSubCollapse = (index: number) => {
        setSubMenueCollapse(prev => ({ ...prev, [index]: !prev[index] }));
    };

    const listHeading = (iconName, item) => (
        <Space style={{ width: '100%' }} direction="horizontal">
            <Button type="text" icon={getIcon({ name: iconName ?? 'HomeOutlined' })} />
            <Text>{item.name ?? item?.parentMenu ?? item?.subMenu}</Text>
        </Space>
    );

    const debouncedGetDesignations = debounce(async (e = '') => {
        try {
            const resData = await dispatch(getData(`/role?current=1&search=${e}&keys=name`, {}));
            const options = resData.data.map(ele => ({
                label: ele.name,
                value: ele._id,
            }));
            setDesignation(options);
            return resData;
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    }, 500);

    const getDesignations = async (e = '') => {
        debouncedGetDesignations(e);
    };

    const handleChange = (value: any) => {
        setRole(value);
    };

    return (
        <Row gutter={16}>
            <Col span={24}>
                <div className="flex justify-end space-x-2">
                    <Select
                        allowClear
                        showSearch={true}
                        filterOption={false}
                        onSearch={e => getDesignations(e)}
                        style={{ width: '300px' }}
                        placeholder="Please select"
                        onChange={handleChange}
                        options={designation}
                    />
                    <Segmented
                        options={["Edit", "Preview"]}
                        defaultValue="Edit"
                        onChange={(e) => {
                            setIsPreview(e === "Preview");
                        }}
                    />
                </div>
            </Col>
            <Col span={6} className="main_menu">
                <Card title={<Flex justify="space-between"><Title level={5}>Menu List</Title></Flex>}>
                    {respRoutes.map((item, index) => (
                        <div key={item._id}>
                            <div
                                className={selectedItem?._id === item._id ? "draggable-item active-item-class  !cursor-pointer" : "draggable-item !cursor-pointer"}
                                onClick={() => (!item?.list?.length ? setSelectedItem(item) : null)}
                            >
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    {listHeading(item.icon, item)}
                                    <Space>
                                        {item?.list?.length > 0 && (
                                            <Button
                                                type="text"
                                                onClick={() => toggleMainCollapse(index)}
                                                size="small"
                                                icon={mainMenueCollapse[index] ? <UpOutlined /> : <DownOutlined />}
                                            />
                                        )}
                                    </Space>
                                </div>
                            </div>
                            {mainMenueCollapse[index] && item.list?.map((subItem, subIndex) => (
                                <div
                                    key={subItem._id}
                                    className={selectedItem?._id === subItem._id ? "draggable-item padding-left-20 active-item-class !cursor-pointer" : "draggable-item padding-left-20 !cursor-pointer"}
                                    onClick={() => (!subItem?.list?.length ? setSelectedItem(subItem) : null)}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        {listHeading(subItem.icon, subItem)}
                                        <Space>
                                            {subItem?.list?.length > 0 && (
                                                <Button
                                                    type="text"
                                                    onClick={() => toggleSubCollapse(subIndex)}
                                                    size="small"
                                                    icon={subMenueCollapse[subIndex] ? <UpOutlined /> : <DownOutlined />}
                                                />
                                            )}
                                        </Space>
                                    </div>
                                    {subMenueCollapse[subIndex] && subItem.list?.map((subSubItem, subSubIndex) => (
                                        <div
                                            key={subSubItem._id}
                                            className={selectedItem?._id === subSubItem._id ? "draggable-item padding-left-40 active-item-class !cursor-pointer" : "draggable-item padding-left-40 !cursor-pointer"}
                                            onClick={() => setSelectedItem(subSubItem)}
                                        >
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                {listHeading(subSubItem.icon, subSubItem)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    ))}
                </Card>
            </Col>
            <Col span={18}>
                {selectedItem && <EditAccess mainMenu={selectedItem} role={role} isPreview={isPreview} />}
            </Col>
        </Row>
    );
};

const mapStateToProps = (state: any) => ({
    isAuthenticated: state.app.isAuthenticated,
    user: state.app.user,
});

export default connect(mapStateToProps)(Access);
